export default __webpack_public_path__ + "static/media/GTC-Logo.122645f7.svg";